import { useRef } from "react";
import { graphql, useFragment } from "react-relay";
import Suspense from "@/common/Suspense";
import CompetitionApprovalsFilter from "./Filters";
import Submissions, { SubmissionsHandle } from "./Submissions";
import { CompetitionApprovalsFragment$key } from "./__generated__/CompetitionApprovalsFragment.graphql";
import { useCompetitionApprovalsFilters } from "@/pages/params/CompetitionApprovalPage";

const Fragment = graphql`
  fragment CompetitionApprovalsFragment on Competition
  @argumentDefinitions(needsApproval: { type: "Boolean", defaultValue: null }) {
    anySubmission: submissions(first: 1) {
      edges {
        cursor
      }
    }
    ...SubmissionsCompetitionApprovalsFragment
      @arguments(needsApproval: $needsApproval)
  }
`;

export interface CompetitionApprovalsProps {
  competition: CompetitionApprovalsFragment$key;
}

export default function CompetitionApprovals(props: CompetitionApprovalsProps) {
  const competition = useFragment(Fragment, props.competition);
  const [filters, setFilters] = useCompetitionApprovalsFilters();

  const submissionsRef = useRef<SubmissionsHandle>(null);

  if (competition.anySubmission.edges.length <= 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <CompetitionApprovalsFilter
        filters={filters}
        onFiltersChange={(filters) => {
          setFilters(filters);
          submissionsRef.current?.refetch(filters);
        }}
      />

      <Suspense>
        <Submissions ref={submissionsRef} competition={competition} />
      </Suspense>
    </div>
  );
}
